
import Login from './components/login/Login.vue';

import LessonWrapper from './components/lesson/LessonWrapper.vue';
import Lesson from './components/lesson/Lesson.vue';
import LessonCategory from './components/lesson/LessonCategory.vue';
import LessonMovie from './components/lesson/LessonMovie.vue';
import LessonReview from './components/lesson/LessonReview.vue';
import LessonQuiz from './components/lesson/LessonQuiz.vue';
import LessonExam from './components/lesson/LessonExam.vue';
import LessonExplanation from './components/lesson/LessonExplanation.vue';

import Profile from './components/profile/Profile.vue';
import EditProfile from './components/profile/edit-profile/EditProfile.vue';
import EditEmail from './components/profile/edit-email/EditEmail.vue';
import EditPassword from './components/profile/edit-password/EditPassword.vue';

import Situation from './components/profile/Situation.vue';
import SituationDetail from './components/profile/SituationDetail.vue';

import NoticeWrapper from './components/notice/NoticeWrapper.vue';
import NoticeList from './components/notice/NoticeList.vue';
import NoticeDetail from './components/notice/NoticeDetail.vue';

// register
import Trial from './components/singup/Trial.vue';
import Expired from './components/singup/Expired.vue';

// stripe
import Purchase from './components/stripe/Purchase.vue';
import PurchaseFinished from './components/stripe/PurchaseFinished.vue';

import SubscriptionDetail from './components/stripe/SubscriptionDetail.vue';
// Inquiry
import InquiryWrapper from './components/inquiry/InquiryWrapper.vue';
import InquiryList from './components/inquiry/InquiryList.vue';
import InquiryMessage from './components/inquiry/InquiryMessage.vue';



export default [
  {
    path: '/apps',
    name: 'apps',
    redirect: {
      name: 'lesson'
    }
  },
  {
    path: '/apps/login',
    name: 'login',
    component: Login,
    meta: {requiresGuest: true}
  },
  {
    path: '/apps/trial',
    name: 'apps.trial',
    component: Trial,
    meta: {requiresAuth: true }
  },
  {
    path: '/apps/expired',
    name: 'apps.expired',
    component: Expired,
    meta: {requiresAuth: true }
  },
  {
    path: '/apps/purchase',
    component: LessonWrapper,
    children: [
      {
        path: '',
        name: 'apps.purchase',
        component: Purchase,
        meta: {requiresAuth: true}
      },
      {
        path: 'finished',
        name: 'apps.purchase.finished',
        component: PurchaseFinished,
        meta: {requiresAuth: true }
      }
    ]
  },
  {
    path: '/apps/lesson',
    component: LessonWrapper,
    children: [
      {
        path: '',
        name: 'lesson',
        component: Lesson,
        meta: {requiresAuth: true}
      },
      {
        path: ':category',
        name: 'lesson.category',
        component: LessonCategory,
        meta: {requiresAuth: true},
        props: true
      },
      {
        path: ':lesson_id/movie/:content_order',
        name: 'lesson.movie',
        component: LessonMovie,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/quiz/:content_order',
        name: 'lesson.quiz',
        component: LessonQuiz,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/review',
        name: 'lesson.review',
        component: LessonReview,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/exam',
        name: 'lesson.exam',
        component: LessonExam,
        meta: {requiresAuth: true}
      },
      {
        path: ':lesson_id/explanation/:step',
        name: 'lesson.explanation',
        component: LessonExplanation,
        meta: {requiresAuth: true},
        props: true
      }
    ]
  },
  {
    path: '/apps/profile',
    component: LessonWrapper,
    children: [
      {
        path: '',
        name: 'profile',
        component: Profile,
        props: true,
        meta: {requiresAuth: true}
      },
      {
        path: 'edit',
        name: 'profile.edit',
        component: EditProfile,
        meta: {requiresAuth: true}
      },
      {
        path: 'email',
        name: 'profile.email',
        component: EditEmail,
        meta: {requiresAuth: true}
      },
      {
        path: 'password',
        name: 'profile.password',
        component: EditPassword,
        meta: {requiresAuth: true}
      },
      {
        path: 'situation',
        name: 'profile.situation',
        component: Situation,
        meta: {requiresAuth: true}
      },
      {
        path: 'situation/:category',
        name: 'profile.situation.detail',
        component: SituationDetail,
        meta: {requiresAuth: true},
        props: true
      },
      {
        path: 'subscription',
        name: 'profile.subscription',
        component: SubscriptionDetail,
        meta: {requiresAuth: true}
      },
      {
        path: '*',
        redirect: {
          name: 'profile'
        }
      }
    ]
  },
  {
    path: '/apps/notice',
    component: NoticeWrapper,
    children: [
      {
        path: '',
        name: 'notice',
        component: NoticeList,
        meta: {requiresAuth: true}
      },
      {
        path: ':news_id',
        name: 'notice.detail',
        component: NoticeDetail,
        meta: {requiresAuth: true}
      }
    ]
  },
  {
    path: '/apps/inquiry',
    component: InquiryWrapper,
    children: [
      {
        path: '',
        name: 'inquiry',
        component: InquiryList,
        meta: {requiresAuth: true}
      },
      {
        path: 'message',
        name: 'inquiry.message',
        component: InquiryMessage,
        meta: {requiresAuth: true}
      }
    ]
  }
];